// extracted by mini-css-extract-plugin
module.exports = {"ValuesItem":"ValueItem_ValuesItem__2xiVz"};